import { gsap, MotionPathPlugin } from 'gsap/all';
import { animationServicesIds } from '../components/Constant';

gsap.registerPlugin(MotionPathPlugin);

// the elements ids in clockwise order.
const elementsSequence = animationServicesIds;

/**
 * Assign positions and scale along the path where we want the elements to rest.
 * position - is the position form 0 to 1 around the elipse
 * scale - the scale ratio of the element;
 */

const positions = [
    { position: 0.0, scale: 1 },
    { position: 0.2, scale: 0.99 },
    { position: 0.4, scale: 0.9 },
    { position: 0.6, scale: 0.9 },
    { position: 0.8, scale: 0.99 },
];

// The above should match the initial position of the elements along the elipse path;

/**
 * Fill the initial service's stroke/border color.
 * We need to fill the stroke for the initial element menually later, animation function will
 * take care of this.
 */
export const fillInitialElementStroke = () => {
    gsap.to(`#crop g .bg`, {
        stroke: '#BF0000',
        strokeWidth: '2',
    });
};

/**
 * Calculate new position of the elements
 * Example: On initial positions, viber icon will be at position 2 as described in the above sequence.
 * When a user clicks on viber we one it to become on position 0 and the next element to update their
 * positions as well. so next positions will be viber: 0, kobo: 1, crop: 2, rtv: 3, france: 4
 * @param {string} focusedElement - element id that has been clicked and should anmate to position 0;
 * @param {*} currentPositions - current position of the elements;
 * @returns
 */

export const calculatePosition = (focusedElement, currentPositions) => {
    const currentElementPosition = currentPositions[focusedElement];
    const steps = 5 - currentElementPosition; // nr of steps from current element position to reach 0;

    // reasign all elements positions starting with focused element at 0;
    const nextPositions = elementsSequence.reduce((agg, item) => {
        const newIndex = currentPositions[item] + steps;
        agg[item] = newIndex > 4 ? newIndex - 5 : newIndex;
        return agg;
    }, {});

    return nextPositions;
};

/**
 * Animate elements along the path from their curent positions to new positions;
 * @param {*} currentPositions
 * @param {*} newPositions
 */

export const animate = (currentPositions, newPositions) => {
    elementsSequence.forEach((item) => {
        const startIndex = currentPositions[item]; // element current position index
        const endIndex = newPositions[item]; // element position we need to animate index
        const startPosition = positions[startIndex].position;
        const { position, scale } = positions[endIndex];
        const endPosition = startPosition > position ? 1 + position : position; // force elements to always rotate clockwise;

        gsap.to(`#${item}`, {
            duration: 1,
            scale: scale,
            motionPath: {
                path: '#track',
                align: '#track',
                alignOrigin: [0.5, 0.5],
                start: startPosition,
                end: endPosition,
            },
        });
        gsap.to(`#${item} g .bg`, {
            duration: 1,
            stroke: endIndex === 0 ? '#BF0000' : null,
            strokeWidth: endIndex === 0 ? '2' : '0',
        });
    });
};
